import { Button } from "@/components/ui/button";
import { useUserStore } from "@/stores/user";
import { Download, Plus } from "lucide-react";

interface ProductsHeaderProps {
  onCreateProduct: () => void;
  onExportCsv: () => void;
  productsCount: number;
}

export function ProductsHeader({
  onCreateProduct,
  onExportCsv,
  productsCount,
}: Readonly<ProductsHeaderProps>) {
  const { hasFullAccess } = useUserStore();
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div className="flex items-center">
        <h1 className="text-2xl font-bold tracking-tight">Products</h1>
        <h3 className="text-lg ml-2 text-muted-foreground self-start mt-1">
          ({productsCount})
        </h3>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={onExportCsv}
          disabled={productsCount === 0}
          className="gap-2"
        >
          <Download className="h-4 w-4" />
          Export CSV
        </Button>
        {hasFullAccess() && (
          <Button onClick={onCreateProduct} className="gap-2">
            <Plus className="h-4 w-4" />
            Add Product
          </Button>
        )}
      </div>
    </div>
  );
}
